import { render, staticRenderFns } from "./UserListSubscriptions.vue?vue&type=template&id=2c1f72fc&scoped=true&"
import script from "./UserListSubscriptions.vue?vue&type=script&lang=js&"
export * from "./UserListSubscriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1f72fc",
  null
  
)

export default component.exports